import type { Messages } from './en';

/**
 * Fase E (paquet Ximen): Ximending i el temple de Longshan / Wanhua.
 * Les línies de pràctica d'anglès es queden en anglès expressament.
 */
export const caXimen: Pick<Messages, 'ximen'> = {
  ximen: {
    mapNames: {
      ximen: 'Ximending',
      longshan: 'Temple de Longshan',
    },
    zones: {
      ximen: 'Ximending',
      longshan: 'Temple de Longshan · Wanhua',
      xmCinemaPark: 'Parc del Cinema de Taipei',
      xmCinemaStreet: 'Carrer del Cinema (電影街)',
      xmSquare: 'Plaça dels artistes de carrer',
      xmEmei: 'Carrer Emei',
      xmExit6: 'MRT Ximen · Sortida 6',
      xmRedHouse: 'La Casa Vermella (西門紅樓)',
      xmChengdu: 'Carrer Chengdu',
      xmZhonghua: 'Carrer Zhonghua',
      xmTemple: 'Temple de Longshan de Bangka',
      xmHerbAlley: 'Carreró de les Herbes (青草巷)',
      xmHuaxi: 'Mercat nocturn del carrer Huaxi',
      xmBopiliao: 'Barri històric de Bopiliao',
      xmOldWanhua: 'Wanhua antic',
      xmBangka: 'Parc de Bangka',
    },
    objects: {
      xm_exit6: 'Sortida 6 del MRT',
      xm_mapBoard: 'Mapa del barri',
      xm_meesua: 'Parada de mee sua',
      xm_chicken: 'Parada de pollastre arrebossat',
      xm_ice: 'Taulell de gel picat',
      xm_sticker: 'Fotomaton d’adhesius',
      xm_tea: 'Botiga de te de bombolles',
      xm_claw: 'Màquines de ganxo',
      xm_cinema: 'Taquilla del cinema',
      xm_posters: 'Cartells de pel·lícules',
      xm_sneakers: 'Prestatge de bambes',
      xm_clothes: 'Penjador de roba',
      xm_tattoo: 'Rètol de l’estudi de tatuatges',
      xm_busker: 'Artista de carrer',
      xm_screen: 'Pantalla gegant',
      xm_plaque: 'Placa de Ximending a terra',
      xm_graffiti: 'Mur de grafits',
      xm_redHouse: 'La Casa Vermella',
      xm_market: 'Mercat creatiu del cap de setmana',
      xm_mrtL: 'Estació del MRT de Longshan',
      xm_dragonDoor: 'Porta del Drac (entrada)',
      xm_pillar: 'Columnes de dracs de bronze',
      xm_waterfall: 'Jardí de la cascada',
      xm_burner: 'Gran encenser',
      xm_offer: 'Taula d’ofrenes',
      xm_moon: 'Blocs de lluna',
      xm_sticks: 'Bastonets de la fortuna',
      xm_roof: 'Teulada de cua d’oreneta',
      xm_herbTea: 'Parada de te d’herbes',
      xm_herbSign: 'Rètol del Carreró de les Herbes',
      xm_bopiliao: 'Plafó d’història de Bopiliao',
      xm_huaxi: 'Portal del carrer Huaxi',
      xm_hxNoodle: 'Parada de fideus danzai',
      xm_hxSoup: 'Parada de sopa de quatre herbes',
      xm_chess: 'Taula d’escacs xinesos',
      xm_pigeons: 'Coloms',
      xm_canoe: 'Escultura de canoa',
      xm_fortune: 'Taula de l’endeví',
      xm_oldIce: 'Gelateria antiga',
    },
    npc: {
      xm_teen1: 'Noia que espera',
      xm_teen2: 'Noi amb el mòbil',
      xm_teen3: 'Noi amb gorra',
      xm_meesuaLady: 'La tieta del mee sua',
      xm_tourist: 'Turista perdut',
      xm_shopper1: 'Comprador',
      xm_shopper2: 'Fan de les bambes',
      xm_skater: 'Skater',
      xm_artist: 'Artista del mercat',
      xm_redGuide: 'Guia de la Casa Vermella',
      xm_cosplayer: 'Cosplayer',
      xm_grandpaX: 'Avi cinèfil',
      xm_volunteer: 'Voluntària del temple',
      xm_fortuneGrandpa: 'Avi endeví',
      xm_worshipper1: 'Fidel',
      xm_worshipper2: 'Àvia amb encens',
      xm_incenseAuntie: 'Venedora d’encens',
      xm_herbLady: 'Senyora del te d’herbes',
      xm_chess1: 'Avi dels escacs',
      xm_chess2: 'Badoc dels escacs',
      xm_pigeonKid: 'Nen que mira els coloms',
      xm_bopiliaoGuide: 'Estudiant d’història',
      xm_nightVendor: 'Cuiner del mercat nocturn',
      xm_tourist2: 'Visitant estrangera',
      xm_taichi: 'Àvia del taitxí',
    },
    items: {},

    common: {
      learned: '📘 Has après una cosa nova!',
      closed: 'Ara és tancat. El mercat nocturn obre al vespre (a partir de les 5).',
      notEnough: 'No tens prou monedes.',
      back: 'Tornar',
    },

    // --- Ximending --------------------------------------------------------------------------
    exit6: {
      text: 'Sortida 6 del MRT Ximen: el punt de trobada més famós de Taipei. Cada cap de setmana, els adolescents hi esperen els seus amics.',
      phrase: 'Let’s meet at Exit 6!', // English practice
      ride: '🚇 Agafar el MRT',
      practice: '🗣️ Practica quedar en anglès',
      q: 'Your friend asks: “Where shall we meet?”', // English practice
      a: ['Let’s meet at Exit 6 at three o’clock.', 'Meet you yesterday at the train.', 'I am Exit 6.'], // English practice
      right: '✅ Perfecte! Digues el lloc i l’hora. El teu amic respon: “See you there!”',
      wrong: 'Mmm, això sona estrany. Digues el lloc i l’hora!',
    },
    mapBoard: {
      text: 'Un mapa de Ximending: el Carrer del Cinema a dalt, el carrer Emei al mig, i la Sortida 6 i la Casa Vermella a baix.',
      q: 'You are at Exit 6. How do you go to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side.', 'Take the escalator up to the sky.', 'Go inside the cinema.'], // English practice
      right: '✅ Sí! La Casa Vermella és just a l’altra banda del carrer des de la Sortida 6.',
      wrong: 'Torna a mirar el mapa: l’edifici vermell és a l’altra banda del carrer gran.',
    },
    meesua: {
      vendor: 'Hello! Big bowl or small bowl?', // English practice
      ok: 'A small bowl of mee sua, please.', // English practice
      bad: ['Give me noodle now!', 'I am a small bowl.'], // English practice
      done: 'Here you go! Here we eat it standing up, with a spoon — no chopsticks. Careful, it’s hot!', // English practice
      after: 'El mee sua (麵線) és una sopa de fideus fins amb budell de porc i molt d’all. No hi ha cadires: tothom se’l menja dret al carrer!',
    },
    tea: {
      vendor: 'Hi! What would you like? How sweet, and how much ice?', // English practice
      ok: 'A bubble milk tea, half sugar, less ice, please.', // English practice
      bad: ['Sugar me, please!', 'I want a hot ice cold tea big.'], // English practice
      done: 'One bubble milk tea, half sugar, less ice! Shake it before you drink!', // English practice
    },
    chicken: {
      vendor: 'Welcome! Spicy or not spicy? Shall I cut it?', // English practice
      ok: 'One chicken cutlet, not spicy, cut, please.', // English practice
      bad: ['Chicken! Chicken! Chicken!', 'Not cut spicy me chicken.'], // English practice
      done: 'Here you are! It’s bigger than your face!', // English practice
    },
    ice: {
      vendor: 'Hello! Mango or strawberry shaved ice?', // English practice
      ok: 'Could I have a mango shaved ice, please?', // English practice
      bad: ['Mango me!', 'I would like a hot snow, please.'], // English practice
      done: 'One mango shaved ice! It’s big — share it with a friend!', // English practice
    },
    claw: {
      text: 'Una botiga sencera de màquines de ganxo (夾娃娃機). Deu monedes per intent. El ganxo és molt traïdor!',
      play: '🧸 Jugar (10 monedes)',
    },
    cinema: {
      text: 'Fa cent anys que Ximending és el carrer del cinema de Taipei. Quina pel·lícula vols veure?',
      films: ['Space Cat', 'Boba Quest', 'Robo Fu'],
      vendor: 'Hi! Which movie, and how many tickets?', // English practice
      ok: 'One ticket for {film}, please.', // English practice
      bad: ['Movie! One! Me!', 'I am a ticket for {film}.'], // English practice
      done: 'Here’s your ticket for {film}. Enjoy the movie!', // English practice
      watched: '🍿 Has vist {film}. Quina pel·li més divertida!',
    },
    posters: {
      text: 'Three posters: SPACE CAT — “A brave cat flies to the moon.” BOBA QUEST — “Two friends look for the best bubble tea.” TYPHOON! — “A family stays home in the storm.”', // English practice
      q: 'Who flies to the moon?', // English practice
      a: ['A brave cat.', 'Two friends.', 'A family.'], // English practice
      right: '✅ Correcte! Space Cat va d’un gat valent.',
      wrong: 'Torna a llegir els cartells!',
    },
    sneakers: {
      text: 'Fileres de bambes de colors. Les que t’agraden et van petites…',
      q: 'How do you ask for another size?', // English practice
      a: ['Do you have these in a bigger size?', 'Shoes bigger you have?', 'I size the shoes, please.'], // English practice
      right: '✅ Genial! El dependent somriu: “Sure, let me check!”', // English practice
      wrong: 'Prova amb una pregunta educada: “Do you have…?”',
    },
    clothes: {
      text: 'Un penjador de rebaixes amb samarretes de tots els colors. T’agrada la groga.',
      q: 'How do you ask to try it on?', // English practice
      a: ['Can I try this on, please?', 'I try you on.', 'This is on me?'], // English practice
      right: '✅ Sí! “The fitting room is at the back.”', // English practice
      wrong: 'Mmm. Comença amb “Can I…?”',
    },
    tattoo: {
      text: 'Un estudi de tatuatges. Els tatuatges de debò són només per a adults (18+)… però l’artista s’ofereix a dibuixar-te una estrella temporal a la mà!',
      get: '⭐ Una estrella temporal (10 monedes)',
      done: 'A sparkly star on your hand! “Temporary” means it washes off in a few days.', // English practice
    },
    sticker: {
      text: 'Un fotomaton d’adhesius (大頭貼)! Tria un marc i posa. 30 monedes.',
      frames: ['🌸 Flors', '🐱 Orelles de gat', '✨ Purpurina'],
      cheese: 'Say cheese!', // English practice
      done: 'Clic! Surten els adhesius: ulls enormes, purpurina i el teu millor somriure.',
    },
    busker: {
      dancer: 'Un ballarí de carrer fa popping i gira al ritme de la música. La gent fa rotllana.',
      singer: 'Una cantant amb guitarra toca una cançó suau. La gent es gronxa i grava amb el mòbil.',
      none: 'Ara no actua ningú. Els artistes de carrer de Ximending necessiten una llicència; actuen des de mig matí fins a la nit.',
      watch: '👀 Mirar l’espectacle',
      tip: '🪙 Donar 10 monedes de propina',
      cheer: 'That was amazing!', // English practice
      watched: '👏 Has aplaudit amb tot el públic!',
      thanks: 'The performer bows: “Thank you so much!”', // English practice
    },
    screen: {
      text: 'The giant screen flashes adverts all day: a concert, a new game, and a bubble tea ad that says “BUBBLE TEA NT$50”.', // English practice
      q: 'How much is the bubble tea in the ad?', // English practice
      a: ['Fifty dollars.', 'Fifteen dollars.', 'Five hundred dollars.'], // English practice
      right: '✅ Correcte: fifty (50). Compte: fifteen és 15!',
      wrong: 'Torna a mirar: un 5 i un 0…',
    },
    plaque: {
      text: '“Ximen” (西門) vol dir Porta de l’Oest: la porta oest de l’antiga muralla de Taipei era a prop d’aquí. Ximending (西門町) és el Barri de la Porta de l’Oest.',
      phrase: 'Ximending means West Gate District.', // English practice
    },
    graffiti: {
      text: 'Al Parc del Cinema de Taipei es pot pintar en aquest mur: els artistes l’omplen de grafits nous tota l’estona.',
      q: 'What colour is the word 西門?', // English practice
      a: ['Pink.', 'Green.', 'Black.'], // English practice
      right: '✅ Sí, rosa llampant!',
      wrong: 'Mira el primer grafit de l’esquerra!',
    },
    redHouse: {
      text: 'La Casa Vermella (西門紅樓) es va construir el 1908 com el primer mercat públic de Taiwan. La façana és un octàgon, amb una nau en forma de creu al darrere. Avui és plena de botiguetes de dissenyadors joves.',
      q: 'How many sides does an octagon have?', // English practice
      a: ['Eight.', 'Six.', 'Ten.'], // English practice
      right: '✅ Vuit! “Octo” vol dir vuit, com el pop (octopus), que té vuit braços.',
      wrong: 'Compta els costats de l’edifici del davant!',
    },
    market: {
      text: 'El mercat creatiu del cap de setmana: clauers fets a mà, postals, joies i te.',
      q: 'You like a keychain. What do you say?', // English practice
      a: ['How much is this keychain?', 'Keychain money you?', 'I am a keychain.'], // English practice
      right: '✅ “It’s 30 dollars. I made it myself!”', // English practice
      wrong: 'Prova amb “How much is…?”',
      buy: '🔑 Comprar el clauer (30 monedes)',
      bought: 'T’has comprat un clauer fet a mà!',
    },

    // --- Temple de Longshan -----------------------------------------------------------------
    mrtL: {
      text: 'Estació de Longshan. La sortida dona just al parc de Bangka, davant del temple.',
      ride: '🚇 Agafar el MRT',
    },
    etiquette: {
      intro: 'Abans d’entrar, la voluntària comprova que coneixes les normes del temple.',
      qs: [
        { q: 'Which door do you use to go IN?', a: ['The right door — the Dragon Door.', 'The middle door.', 'The left door — the Tiger Door.'] }, // English practice
        { q: 'And which door do you use to go OUT?', a: ['The left door — the Tiger Door.', 'The Dragon Door again.', 'Through the window.'] }, // English practice
        { q: 'Can you step on the wooden door sill?', a: ['No, step over it.', 'Yes, jump on it.', 'Sit on it.'] }, // English practice
      ],
      right: '✅ Correcte!',
      wrong: '❌ No ben bé. Recorda: s’entra pel drac i se surt pel tigre!',
      done: 'Well done! “Enter by the right door (dragon side), exit by the left (tiger side).” The middle door is for the gods.', // English practice
    },
    pillar: {
      text: 'Una parella molt especial de columnes de bronze protegeix la porta principal: a cadascuna, un drac s’enrosca fins a la teulada.',
      q: 'What are these pillars made of?', // English practice
      a: ['Bronze — a metal.', 'Wood.', 'Chocolate.'], // English practice
      right: '✅ De bronze! Toca-la amb compte: és fresqueta i llisa.',
      wrong: 'Mmm. Són fosques i brillants, com monedes antigues…',
    },
    waterfall: {
      text: 'Una petita cascada cau en un estany de carpes koi a l’entrada del temple. El so de l’aigua ajuda la gent a calmar-se abans de pregar.',
      phrase: 'The water sounds so peaceful.', // English practice
    },
    burner: {
      text: 'El gran encenser (天公爐) és per a l’Emperador de Jade, el déu del cel. La gent agafa l’encens amb les dues mans, fa tres reverències i demana un desig en silenci.',
      bow: '🙏 Fes tres reverències i demana un desig',
      wish: 'I wish my family good health.', // English practice
      done: 'Fas tres reverències. El fum puja cap al cel amb el teu desig.',
    },
    offer: {
      text: 'Fruita, flors i pastissos per als déus. La pinya agrada molt: en taiwanès, “pinya” (ông-lâi) sona com “arriba la bona sort”.',
      q: 'Which fruit is yellow, spiky and sweet?', // English practice
      a: ['A pineapple.', 'A banana.', 'A grape.'], // English practice
      right: '✅ Una pinya! 旺來: arriba la bona sort!',
      wrong: 'Punxa… i és groga…',
    },
    moon: {
      text: 'Blocs de lluna (擲筊, “poe”): fes als déus, dins del teu cor, una pregunta de sí o no, i després deixa caure els dos blocs vermells en forma de mitja lluna.',
      throw: '🌙 Fes una pregunta i llança',
      results: [
        { name: '聖筊 — Resposta sagrada', text: 'Un costat pla amunt i un costat rodó amunt: la resposta és SÍ!', en: 'The answer is yes!' }, // English practice
        { name: '笑筊 — Resposta rialera', text: 'Els dos costats plans amunt: els déus riuen. La teva pregunta no és clara, torna a preguntar!', en: 'Please ask again.' }, // English practice
        { name: '陰筊 — Resposta enfadada', text: 'Els dos costats rodons amunt: la resposta és NO, o ara no.', en: 'The answer is no.' }, // English practice
      ],
      again: '🌙 Llançar una altra vegada',
    },
    sticks: {
      text: 'Bastonets de la fortuna (求籤): sacseja el gobelet de bambú fins que caigui un bastonet amb un número, i després busca’n el poema als calaixets.',
      shake: '🎋 Sacsejar el gobelet',
      got: 'Cau el bastonet número {n}! La teva fortuna diu:',
      fortunes: [
        'Slow and steady wins the race. Keep going!', // English practice
        'A good friend will help you very soon.', // English practice
        'Be brave and say hello: a new friend is waiting.', // English practice
        'Your hard work will grow like a tree.', // English practice
        'Share what you have, and happiness comes back to you.', // English practice
        'Listen carefully today: you will learn something important.', // English practice
        'After the rain comes the rainbow.', // English practice
        'Your family is proud of you.', // English practice
      ],
    },
    roof: {
      text: 'Mira amunt! Les puntes de la teulada es corben cap amunt com la cua d’una oreneta (燕尾脊). Els carenals són plens de dracs i figuretes fetes amb trossets de porcellana de colors (剪黏).',
      q: 'What bird do the roof ends look like?', // English practice
      a: ['A swallow.', 'A penguin.', 'A chicken.'], // English practice
      right: '✅ Una oreneta! Per això se’n diu teulades de cua d’oreneta.',
      wrong: 'Un ocellet amb la cua en forma de forquilla…',
    },
    herbTea: {
      vendor: 'Herbal tea! It cools you down. Hot or cold?', // English practice
      ok: 'A cup of cold herbal tea, please.', // English practice
      bad: ['Herb me cold!', 'I am a herbal tea.'], // English practice
      done: 'Here you go. It’s a little bitter, but perfect on a hot day!', // English practice
    },
    herbSign: {
      text: 'El Carreró de les Herbes (青草巷): fa més de cent anys que aquestes botigues venen herbes fresques per fer te i remeis casolans de tota la vida.',
      phrase: 'These herbs smell fresh.', // English practice
    },
    bopiliao: {
      text: 'Bopiliao (剝皮寮) és un dels carrers antics més ben conservats de Taipei: cases-botiga de maó vermell de la dinastia Qing i de l’època japonesa, amb porxos (騎樓) per protegir-se de la pluja.',
      q: 'What are the old buildings made of?', // English practice
      a: ['Red bricks.', 'Glass.', 'Snow.'], // English practice
      right: '✅ De maó vermell! I els porxos protegeixen del sol i de la pluja.',
      wrong: 'Mira les parets: són vermelles…',
    },
    huaxi: {
      text: 'El mercat nocturn del carrer Huaxi (華西街夜市) és un dels més antics de Taipei, amb un carrer cobert darrere del seu portal vermell ben decorat. Les parades obren al vespre.',
    },
    hxNoodle: {
      vendor: 'Danzai noodles! Small bowls, big taste. How many?', // English practice
      ok: 'One bowl of danzai noodles, please.', // English practice
      bad: ['Noodle one me!', 'I would like a bowl of chopsticks.'], // English practice
      done: 'Here you are! Shrimp, pork and a little egg on top.', // English practice
    },
    hxSoup: {
      vendor: 'Four-herb soup, nice and warm. Want one?', // English practice
      ok: 'Can I have a four-herb soup, please?', // English practice
      bad: ['Soup! Give!', 'I am four herbs.'], // English practice
      done: 'Here! It’s good for your tummy.', // English practice
    },
    chess: {
      text: 'Dos avis juguen a escacs xinesos (象棋) sota el banià. Una colla de gent mira i dona consells que ningú no ha demanat!',
      q: 'In chess, what do you say when you attack the king?', // English practice
      a: ['Check!', 'Hello!', 'Goodbye!'], // English practice
      right: '✅ “Check!” L’avi riu: “Your move!”', // English practice
      wrong: 'És una paraula curta… comença per “ch”.',
    },
    pigeons: {
      text: 'Un estol de coloms picoteja pel parc i després arrenca a volar tots alhora.',
      q: 'Count them in English! How many pigeons?', // English practice
      a: ['Eleven.', 'Seven.', 'Twenty.'], // English practice
      right: '✅ Onze! Ben comptat.',
      wrong: 'Torna a comptar, a poc a poc!',
    },
    canoe: {
      text: '“Bangka” (艋舺), l’antic nom de Wanhua, ve de la paraula ketagalan per a “canoa”. Fa molt de temps, la gent remava en canoa pel riu per comerciar.',
      phrase: 'Bangka means canoe.', // English practice
    },
    fortune: {
      text: 'L’avi endeví et mira la mà i somriu.',
      reads: [
        'You will learn a lot of English this year.', // English practice
        'You have a kind heart. People like to be near you.', // English practice
        'Something you lost will come back to you.', // English practice
        'A trip will bring you a happy surprise.', // English practice
      ],
      thanks: 'Thank you, grandpa!', // English practice
    },
    oldIce: {
      vendor: 'Welcome to our old ice shop! Since 1960! What would you like?', // English practice
      ok: 'One bowl of fruit shaved ice, please.', // English practice
      bad: ['Ice fruit me now!', 'I would like a hot snowman.'], // English practice
      done: 'Here you go! Mango, watermelon and pineapple on fluffy ice.', // English practice
    },

    // --- Persones ---------------------------------------------------------------------------
    talk: {
      xm_teen1: ['Estem esperant els nostres amics. Tothom queda a la Sortida 6!', 'Pràctica d’anglès: “I’m here! Where are you?”', 'Després anirem a buscar te de bombolles. Amb mig sucre, és clar.'],
      xm_teen2: ['La meva amiga torna a arribar tard… Diu “I’m on my way!”', 'Ximending és el millor lloc per fer fotos. Mira quants neons!'],
      xm_teen3: ['Has provat el fotomaton d’adhesius? Et posa uns ulls enormes!', 'Pràctica d’anglès: “Let’s take a selfie!”'],
      xm_shopper1: ['Aquestes bambes estan d’oferta: en compres unes i te’n regalen unes altres!', 'Pràctica d’anglès: “It’s on sale!” vol dir que és més barat que de costum.'],
      xm_shopper2: ['Col·lecciono bambes. En tinc trenta parells!', 'Aquí les botigues obren tard, cap a les onze, i tanquen molt tard.'],
      xm_skater: ['El Parc del Cinema de Taipei és el millor lloc per patinar. I pots pintar al mur!', 'Pràctica d’anglès: “Watch this trick!”'],
      xm_artist: ['Faig els clauers a mà. Cadascun és diferent!', 'Torna dissabte o diumenge per al mercat creatiu.'],
      xm_redGuide: ['La Casa Vermella va obrir el 1908 com a mercat. Després va ser un teatre i també un cinema!', 'Pràctica d’anglès: “octagon” = 8 costats, “cross” = ✚.'],
      xm_cosplayer: ['Avui vaig disfressada de la meva heroïna d’anime preferida!', 'Pràctica d’anglès: “Can I take a photo with you?” — “Sure!”'],
      xm_grandpaX: ['Quan jo era jove, Ximending tenia més de vint cinemes!', 'Al Carrer del Cinema encara hi ha cinemes antics. El cinema és màgia, xaval.'],
      xm_volunteer: [],
      xm_fortuneGrandpa: [],
      xm_worshipper1: ['Vinc cada diumenge a pregar per la meva família.', 'Pràctica d’anglès: “I pray for good health.”'],
      xm_worshipper2: ['El temple de Longshan té gairebé tres-cents anys. Es va construir el 1738!', 'Aquí hi viuen molts déus: Guanyin, Mazu… i fins i tot el déu dels exàmens!'],
      xm_incenseAuntie: ['Encens i flors per als déus! Avui tinc flors fresques.', 'Pràctica d’anglès: “Would you like some incense?”'],
      xm_chess2: ['Psst… hauria de moure el cavall. No li diguis que t’ho he dit!', 'En els escacs xinesos les peces són rodones i porten caràcters escrits.'],
      xm_pigeonKid: ['Quan algú corre, els coloms arrenquen a volar tots junts! Xxt, camina a poc a poc.', 'Pràctica d’anglès: “Look! They’re flying!”'],
      xm_bopiliaoGuide: ['Estudio la història de Wanhua. Això era el port amb més moviment de Taipei!', 'Aquí s’hi roden pel·lícules perquè el carrer sembla molt antic.'],
      xm_nightVendor: ['El mercat nocturn obre a les cinc. Vine amb gana!', 'Pràctica d’anglès: “What do you recommend?” — “The danzai noodles!”'],
      xm_taichi: ['El taitxí de cada matí em manté jove! A poc a poc… i… respira.', 'Pràctica d’anglès: “Breathe in… breathe out.”'],
    },
    tourist: {
      ask: 'Excuse me! How do I get to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side, near Exit 1.', 'Turn into a cinema and jump.', 'I am the Red House.'], // English practice
      right: '✅ “Thank you so much! You speak great English!”', // English practice
      wrong: 'El turista fa cara de no entendre res. Torna-ho a provar!',
    },
    tourist2: {
      ask: 'Excuse me, which door do I use to go into the temple?', // English practice
      a: ['The right door — the Dragon Door.', 'The middle door, it’s the biggest.', 'Any window is fine.'], // English practice
      right: '✅ “The Dragon Door, thank you! And out by the Tiger Door?” — “Yes!”', // English practice
      wrong: 'Mmm… recorda el drac i el tigre!',
    },
    chessTalk: '“Your move!” The grandpa waits for you to watch closely.', // English practice
    incenseBuy: '🌸 Comprar encens (5 monedes)',
    incenseBought: 'Has comprat tres bastonets d’encens. Fes-los servir al gran encenser!',
  },
};
